(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    // Size Guide button + modal around this chart on product pages (markup in variant-picker)
  class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('dialog');
      this.querySelector('.size_guide_button').addEventListener('click', () => this.modal.showModal());

      // The X button, a click on the backdrop (which targets the dialog itself) and Escape all close with the animation
      this.modal.addEventListener('click', (e) => {
        if(e.target === this.modal || e.target.closest('.size_guide_close')) this.close();
      })
      this.modal.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.close();
      })
    }

    async close() {
      this.modal.classList.add('closing');
      await Promise.allSettled(this.modal.getAnimations().map((animation) => animation.finished));
      this.modal.close();
      this.modal.classList.remove('closing');
    }
  }

  customElements.define('size-guide', SizeGuide);
  } catch(e) { console.error(e); }
})();

})();
